/* When ZUZU opened.
 *
 * The date was once hardcoded as a bare string in six places across the
 * marketing site, which is how the booking screens ended up not mentioning it
 * at all. Everything that depends on it now reads it from here.
 *
 * The club opened on 14 september 2026. The date is kept because the live
 * "open now" logic (zzHelpers ZZ_IS_OPEN_NOW) still gates on it, but the
 * member-facing copy no longer counts down to it — it just says we're open.
 *
 * ZZ_OPEN_LABEL carries the member-facing casing: lowercase per the brand
 * voice, so it can be dropped straight into copy without a text-transform. */

/** Opening day, SAST. Members read booking dates as South African time. */
export const ZZ_OPENING_DATE = "2026-09-14";

/** Member-facing status badge — already lowercase. */
export const ZZ_OPEN_LABEL = "we're open";

/**
 * Has opening day arrived? Compared in SAST (UTC+2, no DST) so the switch
 * happens at midnight in Cape Town rather than at midnight UTC.
 */
export function zzIsOpen(now: Date = new Date()): boolean {
  const sast = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Africa/Johannesburg",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
  return sast >= ZZ_OPENING_DATE;
}
